















































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ElImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import { Table } from "@/utils/decorator";
import { emptyToLine, splitThousands } from "@/utils/common";
import dayjs from "dayjs";

const finance = namespace("finance");
@Component({
  components: { ElImageViewer }
})
@Table("loadListData")
export default class InvoiceManage extends Vue {
  @finance.Action getInvoiceList;
  dayjs = dayjs;
  splitThousands = splitThousands;
  searchForm = {
    invoiceNo: "",
    issueDateFrom: "",
    issueDateTo: "",
    titleName: "",
    orderNo: "",
    payOrderNo: ""
  };
  showViewer: boolean = false;
  imgUrl: string = "";

  invoiceList: any[] = [];
  searchList: any[] = [
    {
      label: window._I18N.t("finance.invoice-date"),
      type: "daterange",
      value: "",
      prop: "issueDateFrom"
    },
    {
      label: window._I18N.t("finance.invoice-title"),
      type: "input",
      value: "",
      prop: "titleName"
    },
    {
      label: window._I18N.t("finance.invoice-num"),
      type: "input",
      value: "",
      prop: "invoiceNo"
    },
    {
      label: window._I18N.t("finance.business-number"),
      type: "input",
      value: "",
      prop: "orderNo"
    },
    {
      label: window._I18N.t("finance.receipt-payment-order-number"),
      type: "input",
      value: "",
      prop: "payOrderNo"
    }
  ];
  emptyToLine = emptyToLine;
  created() {
    this.init();
  }
  closeViewer() {
    this.showViewer = false;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "issueDateFrom") {
          this.searchForm.issueDateFrom = item.value ? item.value[0] : "";
          this.searchForm.issueDateTo = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getInvoiceList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.invoiceList = data.data.list;
      return data;
    });
  }
  handleViewInvoice(row) {
    this.imgUrl = row.invoiceUrl;
    this.showViewer = true;
  }
  handleLinkOrderView(orderNo) {
    let href = "";
    if (orderNo.includes("CG")) {
      href = this.$router.resolve({
        path: `/purchase/purchase-view/${orderNo}`
      }).href;
    } else {
      href = this.$router.resolve({
        path: `/service/view/${orderNo}`
      }).href;
    }
    window.open(href, "_blank");
  }
  handleReceiptView(receiptNo) {
    let { href } = this.$router.resolve({
      path: `/finance/collection-order-view/${receiptNo}`
    });
    window.open(href, "_blank");
  }
  init() {
    this.loadListData();
  }
}
